import React from "react";
import { statusDotClasses } from "@/lib/format";
import { applyFilters } from "@/components/FilterBar";
import StatusInline from "@/components/inline/StatusInline";
import AssigneeInline from "@/components/inline/AssigneeInline";
import PriorityInline from "@/components/inline/PriorityInline";
import DueDateInline from "@/components/inline/DueDateInline";
import TimeInline from "@/components/inline/TimeInline";
import { formatDate } from "@/lib/format";

export default function TableView({ list, tasks, users, filters, canEdit, onOpenTask, onUpdateTask, onRefresh }) {
  const topLevel = tasks.filter((t) => !t.parent_task_id);
  const filtered = applyFilters(topLevel, filters);
  const statuses = list.statuses || [];

  return (
    <div className="bg-white border border-neutral-200 rounded-sm overflow-x-auto" data-testid="table-view">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left bg-neutral-50">
            {["#", "Task", "Status", "Priority", "Assignee", "Due", "Created", "Time"].map((h) => (
              <th key={h} className="px-3 py-2 font-mono-data text-[10px] uppercase tracking-[0.15em] text-neutral-500 border-b border-neutral-200">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-neutral-100">
          {filtered.length === 0 && (
            <tr><td colSpan={8} className="px-3 py-10 text-center text-neutral-500" data-testid="table-empty">No tasks match these filters.</td></tr>
          )}
          {filtered.map((t, idx) => {
            const status = statuses.find((s) => s.id === t.status_id);
            return (
              <tr key={t.id} className="hover:bg-neutral-50/60 transition-colors" data-testid={`table-row-${t.id}`}>
                <td className="px-3 py-2 font-mono-data text-xs text-neutral-500">{String(idx + 1).padStart(3, "0")}</td>
                <td className="px-3 py-2">
                  <button onClick={() => onOpenTask(t.id)} className="font-medium hover:underline flex items-center gap-2" data-testid={`open-task-${t.id}`}>
                    <span className={`w-2 h-2 rounded-full shrink-0 ${statusDotClasses(status?.color || "neutral")}`} />
                    {t.title}
                  </button>
                </td>
                <td className="px-3 py-2"><StatusInline list={list} task={t} canEdit={canEdit} onChange={(v) => onUpdateTask(t.id, { status_id: v })} /></td>
                <td className="px-3 py-2"><PriorityInline task={t} canEdit={canEdit} onChange={(v) => onUpdateTask(t.id, { priority: v })} /></td>
                <td className="px-3 py-2"><AssigneeInline task={t} users={users} canEdit={canEdit} onChange={(v) => onUpdateTask(t.id, { assignee_ids: v })} /></td>
                <td className="px-3 py-2"><DueDateInline task={t} canEdit={canEdit} onChange={(v) => onUpdateTask(t.id, { due_date: v })} /></td>
                <td className="px-3 py-2 text-xs text-neutral-500">{formatDate(t.created_at)}</td>
                <td className="px-3 py-2"><TimeInline task={t} canEdit={canEdit} onLogged={onRefresh} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
